import React, { ReactElement } from 'react'
import { Root } from 'react-dom/client'

import { Game, getApiPath } from 'common'

import { validateState } from '@/logic/validation'
import { ProfileApiImport } from '@/types/api'
import Store, { StoreState } from 'store'
import { embedIndex } from './picker'
import { embedScaling } from './scaling'

async function _loadProfile(id: string, dataLoaded?: Promise<any>) {
  const url = getApiPath(`profiles/load/${Game}/${id}`)
  const result = (await fetch(url).then((response) => response.json())) as ProfileApiImport
  if (!result.data) throw Error('empty profile')

  if (dataLoaded) await dataLoaded

  const { data, ...imported } = result
  return validateState(JSON.parse(data), imported)
}

const buildCache: { [key in string]?: Promise<StoreState> } = {}
export function loadProfile(id: string, dataLoaded?: Promise<any>) {
  if (buildCache[id]) return buildCache[id]!
  return (buildCache[id] = _loadProfile(id, dataLoaded))
}

export async function renderProfile(
  dataLoaded: Promise<any>,
  root: Root,
  profile: string,
  id: number,
  component: ReactElement
) {
  let state = await loadProfile(profile, dataLoaded)

  await dataLoaded

  const store = new Store()
  const index = embedIndex(state, id)
  if (index >= 0) {
    state = { ...state, activeEmbed: index }
  }

  await store.setState(state)

  const style: React.CSSProperties = {}
  const scaling = state.embeds[index] ? embedScaling(state.embeds[index]) : undefined
  const availableWidth = Math.max(200, window.innerWidth - 65)
  if (scaling && availableWidth < scaling.width) {
    const scale = availableWidth / scaling.width
    style.width = availableWidth
    style.height = Math.ceil(scale * scaling.height)
    component = React.cloneElement(component, {
      style: {
        transform: `scale(${scale.toFixed(2)})`,
        transformOrigin: 'top left'
      }
    })
  }

  root.render(
    <Store.Provider store={store}>
      <div className="poeplanner-wrapper" style={style}>
        {component}
      </div>
    </Store.Provider>
  )
}
